// React
import React from 'react';
// External
import { Col, Form } from 'react-bootstrap';
import SelectSearch from 'react-select-search';
import { BsChevronDown } from 'react-icons/bs';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import getFormFieldVal from 'utils/getFormFieldVal';
import validateForm from 'utils/validateForm';
import { addTeamMember } from 'services/managePractice';
import newMember from 'models/Member';
import ACCESS_LEVEL_LIST from 'constants/accessLevelList';
// Styles
import './styles.scss';

class NewMember extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            member: newMember({ memberStatus: 1 }),
            /**
             *  @todo remove the vetId hardcoded and make it dynamic based on the auth credentials
             */
            vetId: '91a39742-9029-11ea-817d-080027ecb0c1',
            errors: []
        };

        this.selectSearchRefs = React.createRef();
        this.bOpenOptions = false;
        this.bEnterPressed = false;
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        event.target.classList.remove('is-invalid');
        // Updates the state
        this.setState((prevState) => {
            const member = { ...prevState.member, ...fieldObj };
            return { member };
        });
    }

    handleInputSelectChange(field, value) {
        const obj = {};
        obj[field] = value;
        let { errors } = this.state;
        errors = this.removeErrorByField(errors, field);
        // Updates the state
        this.setState((prevState) => {
            const member = { ...prevState.member, ...obj };
            return { member, errors };
        });
    }

    /**
     * Function call from the parent component
     */
    async onClickSubmit() {
        try {
            let errors = [];
            await this.setState((prevState) => {
                errors = validateForm(prevState.member);
                errors = this.removeErrorByField(errors, 'id');
                return { errors };
            });
            // Exists before sending the request
            if (errors.length > 0) {
                return;
            }
        } catch (error) {
            console.error(error)
        }
        const formData = {
            vet_account_id: this.state.vetId,
            ...this.state.member.getSugarAPIFormat()
        };
        // If form has no errors then updates the member data
        addTeamMember(formData)
            .then(() => {
                this.props.history.push('/manage-practice');
            }).catch(() => {
                /**
                 * @todo Display an error message
                 */
            });
    }

    onClickCancel() {
        this.props.history.push('/manage-practice');
    }

    /**
     * @param {Array} errors The error list
     * @param {string} field The field error to be removed if exists
     * @returns {Array} String[] with the new list without the field error
     */
    removeErrorByField = (errors, field) => {
        if (errors.includes(field)) {
            const index = errors.indexOf(field);
            errors.splice(index, 1);
            return errors;
        }
        return errors;
    }

    hasError(fieldError) {
        return this.state.errors.find((error) => error === fieldError);
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="New member" />
                    <ContentCard
                        className="mt-62"
                        headerTitle={`${this.state.member.firstName} ${this.state.member.lastName}`}
                    >
                        <Form className="custom-inline-form">
                            <Form.Row>
                                <Form.Group as={Col} controlId="firstName" className="control-group">
                                    <Form.Label>FIRST NAME</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('firstName')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="firstName"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Given name"
                                        value={this.state.member.firstName}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="lastName" className="control-group">
                                    <Form.Label>LAST NAME</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('lastName')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="lastName"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Last name"
                                        value={this.state.member.lastName}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} controlId="email" className="control-group">
                                    <Form.Label>EMAIL</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('email')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="email"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Email"
                                        value={this.state.member.email}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="accessLevel" className="control-group">
                                    <Form.Label>ACCESS LEVEL</Form.Label>
                                    <div className="selector">
                                        <SelectSearch
                                            ref={this.selectSearchRefs}
                                            options={ACCESS_LEVEL_LIST}
                                            onChange={(value) => {
                                                this.handleInputSelectChange('accessLevel', value);

                                                // If the enter key is pressed, set it back to false and then focus back to the dropdown
                                                if (this.bEnterPressed) {
                                                    this.bEnterPressed = false;
                                                    setTimeout(() => this.selectSearchRefs.current.querySelector('input').focus(), 50);
                                                }
                                            }}
                                            renderValue={(valueProps) => (
                                                <Form.Control
                                                    {...valueProps}
                                                    className={
                                                        this.hasError('accessLevel')
                                                            ? 'is-invalid'
                                                            : ''
                                                    }
                                                    name="accessLevel"
                                                    type="text"
                                                    placeholder="Access level"
                                                    value={this.state.member.getAccessLevelLabel()}
                                                    onMouseDownCapture={objEvent => {
                                                        this.bOpenOptions = true;
                                                    }}
                                                    onFocusCapture={objEvent => {
                                                        if (!this.bOpenOptions) {
                                                            objEvent.stopPropagation();
                                                        } else {
                                                            this.bOpenOptions = false;
                                                        }
                                                    }}
                                                    onKeyDownCapture={objEvent => {
                                                        if (objEvent.key === 'Tab') {
                                                            try {
                                                                // Get the currently highlighted option and use it as the selected value
                                                                const value = objEvent.target.parentElement.parentElement.querySelector('.is-highlighted').value;
                                                                
                                                                this.handleInputSelectChange('accessLevel', value)
                                                            } catch(objError) {
                                                                console.log('Error in selecting access level options: ', objError);
                                                            }
                                                        }

                                                        // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                                        if (objEvent.key === 'Enter') {
                                                            this.bOpenOptions = false;
                                                            this.bEnterPressed = true;
                                                        }

                                                        // If the arrow up or down is pressed, open the options
                                                        if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                                            this.selectSearchRefs.current.querySelector('input').blur();

                                                            this.bOpenOptions = true;            

                                                            this.selectSearchRefs.current.querySelector('input').focus();
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        <BsChevronDown />
                                    </div>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </ContentCard>
                </div>
                <FooterBtnActions
                    prevBtnText="Cancel"
                    prevBtnIconActive="false"
                    prevBtnOnCLick={() => this.onClickCancel()}
                    nextBtnText="Create profile"
                    nextBtnIconActive="false"
                    nextBtnOnCLick={() => this.onClickSubmit()}
                />
            </div>
        );
    }
}

export default NewMember;
